import { render, staticRenderFns } from "./SingleFitting.vue?vue&type=template&id=36de34c6&scoped=true&"
import script from "./SingleFitting.vue?vue&type=script&lang=js&"
export * from "./SingleFitting.vue?vue&type=script&lang=js&"
import style0 from "./SingleFitting.vue?vue&type=style&index=0&id=36de34c6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36de34c6",
  null
  
)

export default component.exports